import React, { useContext } from "react";
import { SelectedCardContext } from "../../Context/SelectedCardContext";
import styles from "../About/About.module.css";

const CustomProcurementSupport = () => {
  const { selectedCard } = useContext(SelectedCardContext);

  // Content for each card type
  const contentMap = {
    "Seamless Global Procurement & Logistics Solutions": {
      title: "From essential consumables to complex machinery, we ensure on-time, on-budget delivery without compromising on quality.",
      items: [
        "Strategic supplier relationships across multiple regions",
        "Full logistics coordination from procurement to delivery",
        "Comprehensive documentation management",
        "Quality assurance at every stage of the supply chain"
      ]
    },
    "Procurement Excellence": {
      title: "At Hyproc International, we simplify procurement and shipping, ensuring efficiency, cost control, and reliability at every stage.",
      items: [
        "Our expertise allows you to focus on your core operations while we manage the complexities of sourcing and logistics",
        "Customized procurement strategies based on industry needs",
        "Digital tracking and transparency throughout the procurement process",
        "Cost optimization without compromising on quality or delivery times"
      ]
    },
    "Global Shipping Expertise": {
      title: "Our specialized shipping solutions ensure your goods arrive safely and on time, anywhere in the world.",
      items: [
        "Optimizing transport based on shipment size, weight, and destination",
        "Managing customs paperwork and Incoterms compliance to prevent delays",
        "Coordinating with a global network of carriers to ensure safe, timely delivery",
        "Specialized handling for sensitive, oversized, or hazardous materials"
      ]
    }
  };

  // Get the appropriate content based on the selected card's title
  const getContent = () => {
    if (!selectedCard || !selectedCard.title) {
      return {
        title: "Procurement & Shipping Services",
        items: ["Please select a service to view details"]
      };
    }
    
    return contentMap[selectedCard.title] || {
      title: selectedCard.title,
      items: [selectedCard.description]
    };
  };

  const content = getContent();

  return (
    <div className={`${styles.procurementSupportSection} ${styles.section7}`}>
      <h2>{content.title}</h2>
      <ul>
        {content.items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default CustomProcurementSupport;